@if (mainFilename$ | async; as mainFilename) {
  <jhp-angebot
    *axLazyElement="'jhp-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></jhp-angebot>
}
